import { render, staticRenderFns } from "./WelcomeDigitalTco.vue?vue&type=template&id=9b363e1e"
import script from "./WelcomeDigitalTco.vue?vue&type=script&lang=js"
export * from "./WelcomeDigitalTco.vue?vue&type=script&lang=js"
import style0 from "./WelcomeDigitalTco.vue?vue&type=style&index=0&id=9b363e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports